import { TributaryCreditConcession } from "src/app/ui/models/domains/pbm/product-management/tributary-credit-concession";
import { AbstractParser } from "../../parser";
import { parseTributaryCreditConcessions } from "./product-management-parse-funtions";

export class TributaryCreditConcessionsParser extends AbstractParser<TributaryCreditConcession[]> {
  public parse(payload: any): TributaryCreditConcession[] {
    return parseTributaryCreditConcessions(payload);
  }
}
